<script setup lang="ts" name="VCardHeading"></script>

<template>
  <div class="mb-4 space-y-2 px-6 pt-6">
    <slot />
  </div>
</template>
